import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CurrentUserService } from "@gtmhub/users";

export enum ProfileTheme {
  LIGHT = "light",
  GREY = "gray",
  DARK = "dark",
}

@Injectable({
  providedIn: "root",
})
export class ProfileThemeService {
  private profileTheme$: BehaviorSubject<ProfileTheme> = new BehaviorSubject<ProfileTheme>(ProfileTheme.LIGHT);

  constructor(private currentUserService: CurrentUserService) {
    this.profileTheme$.next(this.currentUserService.getUserSetting("theme") || ProfileTheme.LIGHT);
  }

  public setProfileTheme(newTheme: ProfileTheme): void {
    this.currentUserService.setUserSetting({
      theme: newTheme,
    });
    this.profileTheme$.next(newTheme);
  }

  public getProfileTheme$(): BehaviorSubject<ProfileTheme> {
    return this.profileTheme$;
  }

  public getProfileThemeCurrentValue(): ProfileTheme {
    return this.profileTheme$.value;
  }
}
